var map = {
	"./style-bh.css": [
		9971,
		971
	],
	"./style-en.css": [
		1680,
		680
	],
	"./style-kr.css": [
		8878,
		878
	],
	"./style-sc.css": [
		443,
		443
	],
	"./style-tc.css": [
		3094,
		94
	],
	"./style-th.css": [
		6461,
		461
	],
	"./style-vn.css": [
		1813,
		813
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7141;
module.exports = webpackAsyncContext;